import { type Snapshot } from '@ember-data/store';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class AutomatedMessageRuleSerializer extends ApplicationSerializer {
  // Reads are standard JSON:API (filters + channels arrive as related/included
  // records). On write, the API expects the filters at a non-standard
  // `data.automated_message_rule_filters` location, shaped as
  // `[{ data: { attributes: { entity, attribute, operand, value } } }]`, while
  // `channels` stay a normal relationship. Relocate the filters here.
  serialize(snapshot: Snapshot, options: object) {
    const json = super.serialize(snapshot, options);

    // @ts-expect-error - no typings for the raw JSON:API document
    const data = json.data;

    data.relationships = data.relationships || {};

    delete data.relationships.automated_message_rule_filters;

    // hasMany relationships aren't serialized by default here, so emit the
    // properties + channels linkage the API expects explicitly.
    data.relationships.properties = {
      data: (snapshot.hasMany('properties') || []).map((property) => ({
        type: 'properties',
        id: property.id,
      })),
    };

    data.relationships.channels = {
      data: (snapshot.hasMany('channels') || []).map((channel) => ({
        type: 'channels',
        id: channel.id,
      })),
    };

    data.automated_message_rule_filters = (
      snapshot.hasMany('automatedMessageRuleFilters') || []
    ).map((filterSnapshot) => ({
      data: {
        attributes: {
          entity: filterSnapshot.attr('entity'),
          attribute: filterSnapshot.attr('attribute'),
          operand: filterSnapshot.attr('operand'),
          value: filterSnapshot.attr('value'),
        },
      },
    }));

    return json;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'automated-message-rule': AutomatedMessageRuleSerializer;
  }
}
